import NumberWithTooltip from '@/components/shared/tooltips/NumberTooltip';
import { useBestTrait } from '@/hooks/query/loans/useBestTrait';
import { cn } from '@/utils/helper';

type TraitColumnProps = {
  contractAddress: string;
  tokenId: string;
  textClassName?: string;
};

function TraitColumn({ contractAddress, tokenId, textClassName }: TraitColumnProps) {
  const { data: bestTrait, isLoading: bestTraitLoading } = useBestTrait(contractAddress, tokenId);

  return bestTraitLoading ? (
    <div className='loader !h-[30px] mx-auto'></div>
  ) : bestTrait?.maxTraitPrice ? (
    <NumberWithTooltip fullNumber={bestTrait.maxTraitPrice} symbol='ETH' wrapperClassName='w-full'>
      <p className={cn('text-sm font-normal font-space-mono w-max mx-auto', textClassName)}>{bestTrait.maxTraitPrice.toFixed(2)} ETH</p>
    </NumberWithTooltip>
  ) : (
    <p className={cn('text-sm font-normal font-space-mono w-max mx-auto', textClassName)}>N/A</p>
  );
}

export default TraitColumn;
